import { CurrencySchema } from '@eigtech/currency';
import { z } from 'zod';
import { InvoiceSchema, PaidInvoiceSchema } from '../base/index.js';
import { ServiceEventBaseSchema, serviceEventType } from './service.js';
export const invoicingInvoiceEventType = (eventName) => serviceEventType('invoice', eventName);
export const InvoiceEventTypeSchema = z.enum([
    'created',
    'updated',
    'deleted',
    'sent',
    'paymentMade',
    'downloaded',
]);
export const InvoiceEventType = InvoiceEventTypeSchema.enum;
export const InvoicingEventSchema = ServiceEventBaseSchema.merge(z.object({
    type: invoicingInvoiceEventType(),
    invoice: InvoiceSchema,
    metadata: ServiceEventBaseSchema.shape.metadata.and(z.object({
        requestActor: z.string().optional(),
    })),
}));
export const InvoiceCreatedEventSchema = InvoicingEventSchema.merge(z.object({
    type: invoicingInvoiceEventType(InvoiceEventType.created),
}));
export const InvoiceUpdatedEventSchema = InvoicingEventSchema.merge(z.object({
    type: invoicingInvoiceEventType(InvoiceEventType.updated),
}));
export const InvoiceDeletedEventSchema = InvoicingEventSchema.merge(z.object({
    type: invoicingInvoiceEventType(InvoiceEventType.deleted),
}));
export const InvoiceSentEventSchema = InvoicingEventSchema.merge(z.object({
    type: invoicingInvoiceEventType(InvoiceEventType.sent),
}));
export const InvoicePaymentMadeEventSchema = InvoicingEventSchema.merge(z.object({
    type: invoicingInvoiceEventType(InvoiceEventType.paymentMade),
    invoice: PaidInvoiceSchema.merge(z.object({
        amountPaid: CurrencySchema,
    })),
}));
export const InvoiceDownloadedEventSchema = InvoicingEventSchema.merge(z.object({
    type: invoicingInvoiceEventType(InvoiceEventType.downloaded),
}));
export const InvoiceEventSchema = z.union([
    InvoiceCreatedEventSchema,
    InvoiceDeletedEventSchema,
    InvoiceDownloadedEventSchema,
    InvoicePaymentMadeEventSchema,
    InvoiceSentEventSchema,
    InvoiceUpdatedEventSchema,
]);
